import { LazyModule, LazyAction, LazyImport, registerLazyOrchestrator } from 'owa-bundling';
import {
    onCoprincipalAccountAdded,
    onPreCoprincipalAccountRemoved,
} from 'owa-account-source-list-store';
import { GovernPriority } from 'owa-client-types/lib/GovernPriority';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CalendarSchedulingTaskService" */ './lazyIndex'),
    { name: 'CalendarSchedulingTaskService', govern: GovernPriority.Calendar }
);
registerLazyOrchestrator(
    onPreCoprincipalAccountRemoved,
    lazyModule,
    m => m.onSchedulingTaskAccountRemoved
);
registerLazyOrchestrator(
    onCoprincipalAccountAdded,
    lazyModule,
    m => m.onSchedulingTaskAccountAdded
);

export type { SchedulingTask } from './types/SchedulingTask';
export type { SchedulingDraft } from './types/SchedulingDraft';
export {
    schedulingTaskChanged,
    type SchedulingTaskChangedMessage,
} from './actions/schedulingTaskChanged';

export const lazyLaunchSchedulingDraftForReview: LazyImport<
    typeof lazyIndex.launchSchedulingDraftForReview,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.launchSchedulingDraftForReview);

export const lazyReviewSchedulingTask: LazyAction<
    typeof lazyIndex.reviewSchedulingTask,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reviewSchedulingTask);
export const lazySaveSchedulingTask: LazyAction<
    typeof lazyIndex.saveSchedulingTask,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.saveSchedulingTask);
export const lazyGetSchedulingTasks: LazyAction<
    typeof lazyIndex.getSchedulingTasks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getSchedulingTasks);
export const lazyRenewSchedulingTaskLease: LazyAction<
    typeof lazyIndex.renewSchedulingTaskLease,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.renewSchedulingTaskLease);
export const lazyDeleteSchedulingTasks: LazyAction<
    typeof lazyIndex.deleteSchedulingTasks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteSchedulingTasks);
export const lazyUpdateSchedulingTaskActivityState: LazyAction<
    typeof lazyIndex.updateSchedulingTaskActivityState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateSchedulingTaskActivityState);
export const lazyUpdateSchedulingTaskStatus: LazyAction<
    typeof lazyIndex.updateSchedulingTaskStatus,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateSchedulingTaskStatus);
